var amdi18n={"__root":{"choose_identity":"Choose identity","information_text":"Please choose the credential from which your Cloud Identity is to be derived:","no_usable_identity_available":"No usable identity available","not_available":"not available","not_supported":"not supported","scan_qrcode":"Scan QR-Code","import":"Import","invalid_identity_specified":"No valid Cloud Identity specified"},"__de":{"choose_identity":"Identität auswählen","information_text":"Bitte wählen Sie den Ausweis, aus dem Ihre Cloud Identität abgeleitet werden soll:","no_usable_identity_available":"Keine passende Identität verfügbar","not_available":"nicht verfügbar","not_supported":"nicht unterstützt","scan_qrcode":"QR-Code scannen","import":"Importieren","invalid_identity_specified":"Keine gültige Cloud Identität angegeben"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/IdentityCreationState_strings.js
// module id = 54
// module chunks = 3